/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AddAddress from '../components/AddAddress';
import AddToCart from '../components/AddToCart';
import AdminOrders from '../components/AdminOrders';
import BookingConfirmation from '../components/BookingConfirmation';
import CallCenter from '../components/CallCenter';
import CantAddCart from '../components/CantAddCart';
import CartControls from '../components/CartControls';
import ChangePassword from '../components/ChangePassword';
import Checkout from '../components/Checkout';
import Consent from '../components/Consent';
import ContactUs from '../components/ContactUs';
import CookiePolicy from '../components/CookiePolicy';
import CustomizeCake from '../components/CustomizeCake';
import Dashboard from '../components/Dashboard';
import DraftOrders from '../components/DraftOrders';
import Employees from '../components/Employees';
import FestiveCakes from '../components/FestiveCakes';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeroBanner from '../components/HeroBanner';
import KitchenDisplay from '../components/KitchenDisplay';
import LeftMenu from '../components/LeftMenu';
import Orders from '../components/Orders';
import OrderView from '../components/OrderView';
import PageLoading from '../components/PageLoading';
import PrivacyPolicy from '../components/PrivacyPolicy';
import ProductService from '../components/ProductService';
import RecommendedCakes from '../components/RecommendedCakes';
import RegularCakes from '../components/RegularCakes';
import ResetExpireModal from '../components/ResetExpireModal';
import ResetPassword from '../components/ResetPassword';
import SorryCart from '../components/SorryCart';
import ViewDetail from '../components/ViewDetail';
import ViewMore from '../components/ViewMore';

const components = new Map();
components.set('AddAddress', AddAddress);
components.set('AddToCart', AddToCart);
components.set('AdminOrders', AdminOrders);
components.set('BookingConfirmation', BookingConfirmation);
components.set('CallCenter', CallCenter);
components.set('CantAddCart', CantAddCart);
components.set('CartControls', CartControls);
components.set('ChangePassword', ChangePassword);
components.set('Checkout', Checkout);
components.set('Consent', Consent);
components.set('ContactUs', ContactUs);
components.set('CookiePolicy', CookiePolicy);
components.set('CustomizeCake', CustomizeCake);
components.set('Dashboard', Dashboard);
components.set('DraftOrders', DraftOrders);
components.set('Employees', Employees);
components.set('FestiveCakes', FestiveCakes);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('HeroBanner', HeroBanner);
components.set('KitchenDisplay', KitchenDisplay);
components.set('LeftMenu', LeftMenu);
components.set('Orders', Orders);
components.set('OrderView', OrderView);
components.set('PageLoading', PageLoading);
components.set('PrivacyPolicy', PrivacyPolicy);
components.set('ProductService', ProductService);
components.set('RecommendedCakes', RecommendedCakes);
components.set('RegularCakes', RegularCakes);
components.set('ResetExpireModal', ResetExpireModal);
components.set('ResetPassword', ResetPassword);
components.set('SorryCart', SorryCart);
components.set('ViewDetail', ViewDetail);
components.set('ViewMore', ViewMore);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
